import { render, staticRenderFns } from "./coreReportCopy.vue?vue&type=template&id=d515c8ac&scoped=true&"
import script from "./coreReportCopy.vue?vue&type=script&lang=js&"
export * from "./coreReportCopy.vue?vue&type=script&lang=js&"
import style0 from "./coreReportCopy.vue?vue&type=style&index=0&id=d515c8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d515c8ac",
  null
  
)

export default component.exports